import './Loader.scss';

import type { ReactNode, FC } from 'react';
import classNames from 'classnames';

interface Props {
  fullPage?: boolean;
  overlay?: boolean;
  size?: string;
  strokeWidth?: string;
  text?: ReactNode;
}

const Loader: FC<Props> = (props) => {
  const {
    fullPage = false,
    overlay = false,
    size = '32px',
    strokeWidth = '3px',
    text,
  } = props;

  return (
    <div
      className={classNames('Loader', {
        'Loader--fullPage': fullPage,
        'Loader--overlay': overlay,
      })}
    >
      <div
        className="Loader-indicator"
        style={{ fontSize: size, borderWidth: strokeWidth }}
      />

      {text && <div className="Loader-text">{text}</div>}
    </div>
  );
};

export default Loader;
